export default __webpack_public_path__ + "static/media/top_w576down_1.e3f83392.png";